import { render, staticRenderFns } from "./TablePharmacistForm.vue?vue&type=template&id=5ff706ff&scoped=true&"
import script from "./TablePharmacistForm.vue?vue&type=script&lang=ts&"
export * from "./TablePharmacistForm.vue?vue&type=script&lang=ts&"
import style0 from "./TablePharmacistForm.vue?vue&type=style&index=0&id=5ff706ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff706ff",
  null
  
)

export default component.exports